<div class="status-container container-padding" (click)="showOptions = !showOptions">
  <div class="status-container__first-content">
    <mat-icon class="info-icon" [svgIcon]="'status-info'"></mat-icon>
    {{ 'NGX-MESSAGING.status' | translate }}
  </div>
  <div class="status-container__last-content">
    <mat-icon class="arrow-icon" [svgIcon]="showOptions ? 'arrow_up' : 'arrow_down'"></mat-icon>
  </div>
</div>
@if (showOptions) { @for (option of options; track option.value) {
<div class="status-container">
  <div class="status-container__first-content option-text">
    {{ 'NGX-MESSAGING.FILTER.' + option.text | translate }}
  </div>
  <div class="status-container__last-content">
    <mat-radio-button
      [checked]="selectedChannel()?.status === option.value"
      [value]="option.value"
      (click)="setStatusValue(option.value)"></mat-radio-button>
  </div>
</div>
} }
